/**
 * Converte o PDF em base64 (sem o prefixo "data:application/pdf;base64,") em um Blob.
 * Converte direto, sem `fetch` de URL `data:`, que pode ser bloqueado pela política de segurança (CSP).
 */
export function base64ParaPdf(base64: string): Blob {
  const binario = atob(base64);
  const bytes = new Uint8Array(binario.length);
  for (let i = 0; i < binario.length; i++) {
    bytes[i] = binario.charCodeAt(i);
  }
  return new Blob([bytes], { type: 'application/pdf' });
}
